import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./Main.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import { AppProvider } from "./context/productContext";
import { FilterContextProvider } from "./context/FilterContext";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import SingleProduct from "./pages/SingleProduct";
import Product from "./pages/Product";
import AllProducts from "./pages/AllProducts";
import RegistrationAndLoginForm from "./components/dashboard/RegistrationAndLoginForm";
import Dashboard from "./pages/Dashboard";
import FilterProductPage from "./pages/FilterProductPage";
import AddProduct from "./components/dashboard/AddProduct";
import UpdateProduct from "./components/dashboard/UpdateProducts";
import UploadProduct from "./components/dashboard/UploadProduct";
import DashProducts from "./components/dashboard/DashProducts";
import DashJewelry from "./components/dashboard/DashJewelry";
import ExportProducts from "./components/dashboard/ExportProducts";
import Media from "./components/dashboard/Media";
import ProtectedRoute from "./helper/ProtectedRoute";
import CartPage from "./components/CartPage";
import DesignJewellery from "./pages/DesignJewellery";
import Engagement from "./pages/Engagement";
import Footer from "./components/Footer";
import NikunjDiamondFilter from "./pages/NikunjDiamondFilter";
import DiamondSlider from "./pages/DiamondSlider";
import Checkout from "./pages/Checkout";
import WeddingRing from "./pages/WeddingRing";
import OrderPlaced from "./pages/OrderPlaced";
import ScrollToTop from "./components/ScrollToTop";
import Users from "./components/dashboard/Users";
import Tax from "./components/dashboard/Tax";
import DashOrder from "./components/dashboard/DashOrder";
import AddOrder from "./components/dashboard/AddOrder";

function App() {
  return (
    <AppProvider>
      <ScrollToTop />
      <AuthProvider>
        <FilterContextProvider>
          <CartProvider>
            <Navbar />

            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route
                exact
                path="/singleproduct/:sku"
                element={<SingleProduct />}
              />
              <Route exact path="/product" element={<Product />} />
              <Route
                exact
                path="/productfilter"
                element={<FilterProductPage />}
              />
              <Route exact path="/allproducts" element={<AllProducts />} />
              <Route
                exact
                path="/login"
                element={<RegistrationAndLoginForm />}
              />
              <Route
                exact
                path="/design-your-own-jewellery/:id"
                element={<DesignJewellery />}
              />
              <Route exact path="/engagement" element={<Engagement />} />
              <Route
                exact
                path="/nikunjdiamondfilter"
                element={<NikunjDiamondFilter />}
              />
              <Route exact path="/diamond-slider" element={<DiamondSlider />} />
              <Route exact path="/wedding-rings" element={<WeddingRing />} />
              <Route exact path="/order-placed" element={<OrderPlaced />} />
              <Route exact path="/cart" element={<CartPage />} />
              <Route element={<ProtectedRoute />}>
                <Route exact path="/checkout" element={<Checkout />} />
                <Route exact path="/dashboard" element={<Dashboard />} />
                <Route exact path="/addproducts" element={<AddProduct />} />
                <Route
                  exact
                  path="/updateproduct"
                  element={<UpdateProduct />}
                />
                <Route
                  exact
                  path="/uploadproduct"
                  element={<UploadProduct />}
                />
                <Route exact path="/dashproduct" element={<DashProducts />} />
                <Route exact path="/dashjewelry" element={<DashJewelry />} />
                <Route
                  exact
                  path="/exportproducts"
                  element={<ExportProducts />}
                />
                <Route exact path="/media" element={<Media />} />
                <Route exact path="/users" element={<Users />} />
                <Route exact path="/tax" element={<Tax />} />
                <Route exact path="/admin-order" element={<DashOrder />} />
                <Route exact path="/addorder" element={<AddOrder />} />
              </Route>
            </Routes>
            <Footer />
          </CartProvider>
        </FilterContextProvider>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
